var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotPaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200012 4C0.200012 1.79086 1.99087 0 4.20001 0H12.2C14.4092 0 16.2 1.79086 16.2 4V12C16.2 14.2091 14.4092 16 12.2 16H4.20001C1.99087 16 0.200012 14.2091 0.200012 12V4Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47335 7.55859L7.36397 6.94141C7.11983 6.87109 6.94991 6.64258 6.94991 6.38867C6.94991 6.07031 7.20772 5.8125 7.52608 5.8125H8.821C9.05929 5.8125 9.29366 5.88477 9.48897 6.01758C9.60811 6.09766 9.76827 6.07812 9.86983 5.97852L10.5495 5.31445C10.6882 5.17969 10.6687 4.95508 10.5144 4.83594C10.0358 4.46094 9.43819 4.25195 8.82491 4.25V3.3125C8.82491 3.14062 8.68429 3 8.51241 3H7.88741C7.71554 3 7.57491 3.14062 7.57491 3.3125V4.25H7.52608C6.28194 4.25 5.28194 5.31836 5.39718 6.58594C5.47921 7.48633 6.16671 8.21875 7.0339 8.47266L9.03585 9.05859C9.27999 9.13086 9.44991 9.35742 9.44991 9.61133C9.44991 9.92969 9.1921 10.1875 8.87374 10.1875H7.57882C7.34054 10.1875 7.10616 10.1152 6.91085 9.98242C6.79171 9.90234 6.63155 9.92188 6.52999 10.0215L5.8503 10.6855C5.71163 10.8203 5.73116 11.0449 5.88546 11.1641C6.36397 11.5391 6.96163 11.748 7.57491 11.75V12.6875C7.57491 12.8594 7.71554 13 7.88741 13H8.51241C8.68429 13 8.82491 12.8594 8.82491 12.6875V11.7461C9.73507 11.7285 10.5886 11.1875 10.8894 10.3262C11.3093 9.12305 10.6042 7.88867 9.47335 7.55859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPaidIcon);
export default __webpack_public_path__ + "static/media/not-paid-icon.6f4f8a9dabe801433cfc87626f676964.svg";
export { ForwardRef as ReactComponent };